import { gql } from '@apollo/client'

const BASE_CRASH_COURSE_FIELDS = gql`
  fragment BaseCrashCourseFields on CrashCourseType {
    id
    courseName
    startDate
    link
    price
    topics
    createdAt
    additionalInfo
    author {
      id
      fullName
    }
    subject {
      id
      tabName
    }
    order
  }
`

export const GET_LIST_CRASH_COURSE = gql`
  ${BASE_CRASH_COURSE_FIELDS}
  query findAllCrashCourse($params: CrashCourseQueryInput = {}) {
    findAllCrashCourse(query: $params) {
      count
      items {
        ...BaseCrashCourseFields
      }
    }
  }
`

export const GET_ONE_CRASH_COURSE = gql`
  ${BASE_CRASH_COURSE_FIELDS}
  query findOneCrashCourse($params: String!) {
    findOneCrashCourse(id: $params) {
      ...BaseCrashCourseFields
    }
  }
`

export const CREATE_CRASH_COURSE = gql`
  mutation createCrashCourse($params: CreateCrashCourseInput!) {
    createCrashCourse(createCrashCourseInput: $params) {
      id
    }
  }
`

export const UPDATE_CRASH_COURSE = gql`
  mutation updateCrashCourse($params: UpdateCrashCourseInput!) {
    updateCrashCourse(updateCrashCourseInputFieldName: $params) {
      id
    }
  }
`

export const REMOVE_CRASH_COURSE = gql`
  mutation removeCrashCourse($params: String!) {
    removeCrashCourse(id: $params) {
      affected
    }
  }
`
